(function () {
  'use strict';

  window.NFProjectForm || (window.NFProjectForm = { initialized: {} });

  var STYLE_SURFACES = {
    Standard: ['Matt', 'Holz Fein', 'Holz Rustikal'],
    Modern: ['Matt', 'Holz Fein', 'Holz Rustikal'],
    Iconic: ['Matt', 'Holz Fein', 'Holz Rustikal'],
    Liniert: ['Matt', 'Holz Fein'],
    'Rahmen (normal)': ['Matt', 'Holz Fein'],
    'Rahmen (schmal)': ['Matt', 'Holz Fein'],
    'Rahmen (oval)': ['Matt'],
  };

  var SURFACE_COLORS = {
    Matt: ['Weiß', 'Schwarz', 'Sand', 'Wolken', 'Cardboard', 'Pearl', 'Powder', 'Beige', 'Turmeric', 'Weinrot', 'Wald', 'Spinach', 'Salbei', 'Minze', 'Eukaliptus', 'Blau Grau', 'Meer', 'Nachthimmel', 'Zement', 'Kohle'],
    'Holz Fein': ['Schwarze Eiche', 'Kastanie Braun', 'Grauholz', 'Natürliche Eiche', 'Pekannuss', 'Nussbaum', 'Weiße Eiche'],
    'Holz Rustikal': ['Schwarze Eiche', 'Kastanie Braun', 'Grauholz', 'Natürliche Eiche', 'Pekannuss', 'Weiße Eiche'],
  };

  var COLOR_HEX = {
    'Weiß': '#FFFFFF', Schwarz: '#1A1A1A', Sand: '#C8B898', Wolken: '#E8E3DC', Cardboard: '#B09878',
    Pearl: '#E2D9CC', Powder: '#DDD5CB', Beige: '#CCBA94', Turmeric: '#C89520', Weinrot: '#6B2D3E',
    Wald: '#2D5A27', Spinach: '#3B5C34', Salbei: '#9CAF88', Minze: '#8CC8B0', Eukaliptus: '#5F8A7E',
    'Blau Grau': '#6B7F8E', Meer: '#2E5F80', Nachthimmel: '#1B2838', Zement: '#8A8A8A', Kohle: '#3A3A3A',
    'Schwarze Eiche': '#2C2416', 'Kastanie Braun': '#6B4226', Grauholz: '#8B8378',
    'Natürliche Eiche': '#C4A672', Pekannuss: '#8B6C42', Nussbaum: '#5C4033', 'Weiße Eiche': '#D4C8A8',
  };

  // Cloudflare rejects request bodies over 100 MB before they reach the API.
  // Keep the combined upload safely below that (incl. multipart overhead).
  var MAX_TOTAL_MB = 85;

  window.NFProjectForm.init = function () {
    var container = document.getElementById('nf-project-form-container');
    if (!container) return;
    var sectionId = container.getAttribute('data-section-id') || 'default';
    if (window.NFProjectForm.initialized[sectionId]) return;
    window.NFProjectForm.initialized[sectionId] = true;

    var form = document.getElementById('nf-project-form');
    if (!form) return;

    var API_ENDPOINT = container.getAttribute('data-api-endpoint') || '';
    var imageFiles = [];
    var videoFiles = [];

    var styleSelect = document.getElementById('nf-style');
    var finishSelect = document.getElementById('nf-finish');
    var colorSelect = document.getElementById('nf-color');
    var surfaceWrap = document.getElementById('nf-surface-wrap');
    var colorWrap = document.getElementById('nf-color-wrap');
    var swatchContainer = document.getElementById('nf-color-swatches');
    var currentStyle = '';

    function totalUploadBytes() {
      var total = 0;
      for (var i = 0; i < imageFiles.length; i++) total += imageFiles[i].size;
      for (var j = 0; j < videoFiles.length; j++) total += videoFiles[j].size;
      return total;
    }

    function populateSelect(sel, options, placeholder) {
      sel.innerHTML = '';
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = placeholder || 'Bitte wählen...';
      sel.appendChild(opt);
      for (var i = 0; i < options.length; i++) {
        var o = document.createElement('option');
        o.value = options[i];
        o.textContent = options[i];
        sel.appendChild(o);
      }
    }

    function buildSwatches(colors) {
      swatchContainer.innerHTML = '';
      colorSelect.innerHTML = '<option value="">Bitte wählen...</option>';
      for (var i = 0; i < colors.length; i++) {
        var name = colors[i];
        var hex = COLOR_HEX[name] || '#CCCCCC';
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        colorSelect.appendChild(opt);
        var chip = document.createElement('div');
        chip.className = 'nf-swatch';
        chip.setAttribute('data-value', name);
        var dot = document.createElement('span');
        dot.className = 'nf-swatch-dot';
        dot.style.backgroundColor = hex;
        var label = document.createElement('span');
        label.textContent = name;
        chip.appendChild(dot);
        chip.appendChild(label);
        chip.addEventListener('click', (function (val) {
          return function () {
            var all = swatchContainer.querySelectorAll('.nf-swatch');
            for (var j = 0; j < all.length; j++) all[j].classList.remove('nf-selected');
            this.classList.add('nf-selected');
            colorSelect.value = val;
          };
        })(name));
        swatchContainer.appendChild(chip);
      }
    }

    function clearSwatches() {
      if (swatchContainer) swatchContainer.innerHTML = '';
      if (colorSelect) {
        colorSelect.innerHTML = '<option value="">Bitte wählen...</option>';
        colorSelect.value = '';
      }
    }

    if (styleSelect) {
      styleSelect.addEventListener('change', function () {
        currentStyle = this.value;
        var surfaces = STYLE_SURFACES[currentStyle];
        if (surfaces && surfaces.length > 0) {
          populateSelect(finishSelect, surfaces, 'Bitte wählen...');
          surfaceWrap.classList.add('nf-visible');
          if (surfaces.length === 1) {
            finishSelect.value = surfaces[0];
            finishSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          surfaceWrap.classList.remove('nf-visible');
          finishSelect.value = '';
        }
        colorWrap.classList.remove('nf-visible');
        clearSwatches();
      });
    }

    if (finishSelect) {
      finishSelect.addEventListener('change', function () {
        var surface = this.value;
        var colors = SURFACE_COLORS[surface];
        if (colors && colors.length > 0) {
          var filtered = colors;
          if (
            currentStyle === 'Liniert' ||
            (currentStyle === 'Rahmen (normal)' && surface === 'Holz Fein')
          ) {
            filtered = [];
            for (var i = 0; i < colors.length; i++) {
              if (colors[i] !== 'Nussbaum') filtered.push(colors[i]);
            }
          }
          buildSwatches(filtered);
          colorWrap.classList.add('nf-visible');
        } else {
          colorWrap.classList.remove('nf-visible');
          clearSwatches();
        }
      });
    }

    function setupUpload(inputId, previewId, fileArray, maxFiles, maxSizeMB) {
      var input = document.getElementById(inputId);
      var preview = document.getElementById(previewId);
      if (!input || !preview) return;
      var zone = input.closest('.nf-upload-zone');

      // The whole box opens the file dialog, not just the native input's own
      // small hit area ("Bilder hierher ziehen oder klicken" promises this).
      zone.style.cursor = 'pointer';
      zone.addEventListener('click', function (e) {
        if (e.target === input) return;
        input.click();
      });

      zone.addEventListener('dragover', function (e) {
        e.preventDefault();
        zone.classList.add('nf-dragover');
      });
      zone.addEventListener('dragleave', function () {
        zone.classList.remove('nf-dragover');
      });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        zone.classList.remove('nf-dragover');
        addFiles(e.dataTransfer.files);
      });
      input.addEventListener('change', function () {
        addFiles(this.files);
        this.value = '';
      });

      function addFiles(files) {
        for (var i = 0; i < files.length; i++) {
          if (fileArray.length >= maxFiles) return;
          if (files[i].size > maxSizeMB * 1024 * 1024) {
            alert('Die Datei "' + files[i].name + '" ist zu groß (max. ' + maxSizeMB + ' MB).');
            continue;
          }
          if (totalUploadBytes() + files[i].size > MAX_TOTAL_MB * 1024 * 1024) {
            alert('Alle Dateien zusammen dürfen ' + MAX_TOTAL_MB + ' MB nicht überschreiten. Bitte verkleinern Sie Ihr Video oder entfernen Sie einzelne Fotos.');
            continue;
          }
          fileArray.push(files[i]);
        }
        renderPreviews();
      }

      function renderPreviews() {
        preview.innerHTML = '';
        for (var idx = 0; idx < fileArray.length; idx++) {
          (function (i) {
            var file = fileArray[i];
            var div = document.createElement('div');
            div.className = 'nf-preview';
            if (file.type.indexOf('image/') === 0) {
              var img = document.createElement('img');
              img.src = URL.createObjectURL(file);
              div.appendChild(img);
            } else {
              div.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;width:100%;height:100%;background:#f5f5f5;font-size:0.75rem;color:#666;">' + file.name.substring(0, 12) + '</div>';
            }
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'nf-preview-remove';
            btn.innerHTML = '&times;';
            btn.addEventListener('click', function (ev) {
              ev.stopPropagation();
              fileArray.splice(i, 1);
              renderPreviews();
            });
            div.appendChild(btn);
            preview.appendChild(div);
          })(idx);
        }
      }
    }

    setupUpload('nf-images', 'nf-images-preview', imageFiles, 5, 10);
    setupUpload('nf-videos', 'nf-videos-preview', videoFiles, 1, 50);

    function validate() {
      var valid = true;
      var errorFields = form.querySelectorAll('.nf-error');
      for (var i = 0; i < errorFields.length; i++) errorFields[i].classList.remove('nf-error');

      var nameEl = form.querySelector('#nf-name');
      if (!nameEl.value.trim()) { nameEl.closest('.nf-field').classList.add('nf-error'); valid = false; }

      var emailEl = form.querySelector('#nf-email');
      if (!emailEl.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value)) {
        emailEl.closest('.nf-field').classList.add('nf-error'); valid = false;
      }

      var modelEl = form.querySelector('#nf-model');
      if (!modelEl.value) { modelEl.closest('.nf-field').classList.add('nf-error'); valid = false; }

      var roleEl = form.querySelector('#nf-role');
      if (!roleEl.value) { roleEl.closest('.nf-field').classList.add('nf-error'); valid = false; }

      var locationEl = form.querySelector('#nf-location');
      if (!locationEl.value.trim()) { locationEl.closest('.nf-field').classList.add('nf-error'); valid = false; }

      var orderEl = form.querySelector('#nf-order-number');
      if (!orderEl.value.trim()) { orderEl.closest('.nf-field').classList.add('nf-error'); valid = false; }

      var displayEl = form.querySelector('#nf-display-name');
      if (!displayEl.value) { displayEl.closest('.nf-field').classList.add('nf-error'); valid = false; }

      if (imageFiles.length === 0) {
        var zone = document.getElementById('nf-images-zone');
        if (zone) zone.closest('.nf-field').classList.add('nf-error');
        valid = false;
      }
      return valid;
    }

    var isSubmitting = false;

    function showError(text) {
      var msgError = document.getElementById('nf-msg-error');
      document.getElementById('nf-msg-error-text').textContent = text;
      msgError.classList.add('nf-visible');
      msgError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function doSubmit() {
      if (isSubmitting) return;

      var msgSuccess = document.getElementById('nf-msg-success');
      var msgError = document.getElementById('nf-msg-error');
      msgSuccess.classList.remove('nf-visible');
      msgError.classList.remove('nf-visible');

      if (!validate()) {
        var firstError = form.querySelector('.nf-error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (!API_ENDPOINT) {
        showError('Kein API-Endpunkt konfiguriert. Bitte kontaktieren Sie den Administrator.');
        return;
      }

      // Guard against the Cloudflare 100 MB request limit with a clear message
      // instead of a misleading network error.
      if (totalUploadBytes() > MAX_TOTAL_MB * 1024 * 1024) {
        showError('Ihre Dateien sind zusammen zu groß (max. ' + MAX_TOTAL_MB + ' MB insgesamt). Bitte verkleinern Sie Ihr Video oder entfernen Sie einzelne Fotos.');
        return;
      }

      isSubmitting = true;
      var btn = document.getElementById('nf-submit-btn');
      btn.classList.add('nf-loading');
      btn.setAttribute('aria-disabled', 'true');

      var fd = new FormData();
      fd.append('customer_name', form.querySelector('#nf-name').value.trim());
      fd.append('customer_email', form.querySelector('#nf-email').value.trim());
      fd.append('order_number', form.querySelector('#nf-order-number').value.trim());
      fd.append('display_name', form.querySelector('#nf-display-name').value);
      fd.append('customer_role', form.querySelector('#nf-role').value);
      fd.append('location', form.querySelector('#nf-location').value.trim());
      fd.append('company', (form.querySelector('#nf-company') || {}).value || '');
      fd.append('title', form.querySelector('#nf-title').value.trim());
      fd.append('description', form.querySelector('#nf-description').value.trim());
      fd.append('model', (form.querySelector('#nf-model') || {}).value || '');
      fd.append('style', (form.querySelector('#nf-style') || {}).value || '');
      fd.append('finish', (form.querySelector('#nf-finish') || {}).value || '');
      fd.append('color', (form.querySelector('#nf-color') || {}).value || '');

      for (var i = 0; i < imageFiles.length; i++) fd.append('image_' + i, imageFiles[i]);
      for (var j = 0; j < videoFiles.length; j++) fd.append('video_' + j, videoFiles[j]);

      function finishSubmit() {
        btn.classList.remove('nf-loading');
        btn.removeAttribute('aria-disabled');
      }

      fetch(API_ENDPOINT, { method: 'POST', body: fd })
        .then(function (res) {
          // Non-JSON responses (e.g. Cloudflare error pages) must not be
          // parsed blindly — map them to helpful messages instead.
          return res.json()
            .then(function (data) { return { ok: res.ok, status: res.status, data: data }; })
            .catch(function () { return { ok: res.ok, status: res.status, data: null }; });
        })
        .then(function (result) {
          finishSubmit();
          if (result.ok && result.data && result.data.success) {
            // The server accepted the submission — from here on, NOTHING may
            // surface an error to the user. UI-cleanup exceptions previously
            // fell through to the network-error catch and showed a bogus
            // "Netzwerkfehler" for perfectly successful submissions.
            try {
              form.reset();
              imageFiles.length = 0;
              videoFiles.length = 0;
              var imgPreview = document.getElementById('nf-images-preview');
              var vidPreview = document.getElementById('nf-videos-preview');
              if (imgPreview) imgPreview.innerHTML = '';
              if (vidPreview) vidPreview.innerHTML = '';
              if (surfaceWrap) surfaceWrap.classList.remove('nf-visible');
              if (colorWrap) colorWrap.classList.remove('nf-visible');
              clearSwatches();
            } catch (uiErr) {
              console.error('NF success-UI cleanup error (submission was successful):', uiErr);
            }
            try {
              // NOTE: form.style is shadowed by the <select name="style"> form
              // control (named inputs shadow HTMLFormElement properties), so
              // form.style.setProperty crashed here — use setAttribute instead.
              form.setAttribute('style', 'display: none !important');
              container.classList.add('nf-submitted');
              msgSuccess.classList.add('nf-visible');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (uiErr2) {
              console.error('NF success-message error (submission was successful):', uiErr2);
            }
          } else {
            isSubmitting = false;
            var message;
            if (result.status === 413) {
              message = 'Ihre Dateien sind zusammen zu groß. Bitte verkleinern Sie Ihr Video oder entfernen Sie einzelne Fotos und versuchen Sie es erneut.';
            } else if (result.data && result.data.error) {
              message = result.data.error;
            } else {
              message = 'Beim Senden ist ein Fehler aufgetreten (Code ' + result.status + '). Bitte versuchen Sie es später erneut.';
            }
            showError(message);
          }
        })
        .catch(function () {
          isSubmitting = false;
          finishSubmit();
          showError('Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut. Tipp: Große Videos brauchen je nach Internetverbindung mehrere Minuten.');
        });
    }

    window.NFProjectForm._submit = doSubmit;

    var submitDiv = document.getElementById('nf-submit-btn');
    if (submitDiv) {
      submitDiv.style.pointerEvents = 'auto';
      submitDiv.style.position = 'relative';
      submitDiv.style.zIndex = '99999';
      submitDiv.style.userSelect = 'none';
      submitDiv.style.webkitUserSelect = 'none';
      submitDiv.onclick = function (e) {
        if (e && e.preventDefault) e.preventDefault();
        doSubmit();
      };
      var pointerFired = false;
      submitDiv.addEventListener('pointerdown', function () {
        pointerFired = true;
        setTimeout(function () { pointerFired = false; }, 500);
      });
      submitDiv.addEventListener('pointerup', function () {
        if (pointerFired) {
          pointerFired = false;
          doSubmit();
        }
      });
      submitDiv.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          doSubmit();
        }
      });
    }
  };

  window.NFProjectForm.init();

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId) {
        delete window.NFProjectForm.initialized[e.detail.sectionId];
        window.NFProjectForm.init();
      }
    });
  }
})();
